<template>
  <v-data-table
    hide-actions
    :headers="headers"
    :items="groupedItems"
    no-data-text="Данные отсутствуют"
    class="mb-1 v-data-table--fixed-header"
    style="overflow: auto"
  >
    <template v-slot:headers="props">
      <tr class="text-xs-left px-3">
        <th
          v-for="header in props.headers"
          :key="header.text"
          :style="{
            minWidth: header.width ? `${header.width}px` : 'auto',
            whiteSpace: header.width ? 'normal' : 'nowrap'
          }"
        >
          {{ header.text }}
        </th>
      </tr>
    </template>
    <template v-slot:items="props">
      <tr>
        <template v-if="!props.item.subGroups">
          <td
            v-if="props.item.groupId"
            class="body-2 link"
            @click="() => $emit('action', props.item)"
          >
            {{ props.item.group }}
          </td>
          <td
            v-else
            class="body-2 font-weight-bold"
          >
            {{ props.item.group }}
          </td>
          <td
            v-for="(col, index) in props.item.cols"
            :key="index"
            class="align-top"
          >
            <div
              v-for="(colValue, index) in col"
              :key="index"
              class="py-1"
            >
              <span v-if="Array.isArray(colValue)">
                <a
                  v-for="(value, index) in colValue"
                  :key="index"
                  class="link"
                  @click="() => $emit('action', value)"
                >{{ `${value.title}; ` }}</a></span>
              <span v-else> {{ colValue }}</span>
            </div>
          </td>
        </template>
        <template v-if="props.item.subGroups && !props.item.compactMode">
          <td>
            <v-layout align-center>
              <span class="body-2 font-weight-bold">{{
                props.item.group
              }}</span>
              <v-icon
                class="ma-0"
                @click="compactModeChange(props.item)"
              >
                {{ props.item.compactMode ? "unfold_more" : "unfold_less" }}
              </v-icon>
            </v-layout>
          </td>
          <td
            v-for="(col, index) in props.item.cols"
            :key="index"
            class="align-top"
          >
            <div
              v-for="(colValue, index) in col"
              :key="index"
              class="py-1"
            >
              <span
                v-if="
                  typeof colValue === 'object' &&
                    colValue.subGroup != null &&
                    colValue.subGroup != undefined
                "
                class="font-weight-bold"
              >{{ colValue.subGroup }}</span>
              <span v-else-if="Array.isArray(colValue)">
                <a
                  v-for="(value, index) in colValue"
                  :key="index"
                  class="link"
                  @click="() => $emit('action', value)"
                >{{ `${value.title}; ` }}</a></span>
              <span v-else> {{ colValue }}</span>
            </div>
          </td>
        </template>
        <template v-else-if="props.item.subGroups && props.item.compactMode">
          <td>
            <v-layout align-center>
              <span class="body-2 font-weight-bold">{{
                props.item.group
              }}</span>
              <v-icon
                class="ma-0"
                @click="compactModeChange(props.item)"
              >
                {{ props.item.compactMode ? "unfold_more" : "unfold_less" }}
              </v-icon>
            </v-layout>
          </td>
          <td
            v-for="(col, index) in props.item.cols"
            :key="index"
            class="align-top"
          >
            <div
              v-for="(colValue, index) in col.filter(
                c => c.subGroup != null && c.subGroup != undefined
              )"
              :key="index"
              class="py-1"
            >
              <span
                v-if="
                  typeof colValue === 'object' &&
                    colValue.subGroup != null &&
                    colValue.subGroup != undefined
                "
                class="font-weight-bold"
              >{{ colValue.subGroup }}</span>
            </div>
          </td>
        </template>
      </tr>
    </template>
  </v-data-table>
</template>
<script>
import _ from "lodash";
export default {
  props: ["groups", "subGroups", "headers", "flatItems"],
  data() {
    return {
      groupedItems: [],
    };
  },
  watch: {
    flatItems: {
      handler() {
        this.initGroupedItems();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    initGroupedItems() {
      const newItems = [];

      this.groups.forEach(g => {
        if (!g.subGroup) {
          const items = this.flatItems.filter(f => f.group === g.title);
          if (!items.length) {
            return;
          }
          const elem = { group: g.title, cols: [] };
          if (g.groupId) {
            elem.groupId = g.groupId;
          }
          this.headers.forEach(h => {
            if (h.name === "group") {
              return;
            }
            elem.cols.push(_.map(items, h.name));
          });
          newItems.push(elem);
        } else if (g.subGroup) {
          this.subGroups.forEach(sg => {
            const subItems = this.flatItems.filter(f => {
              return f.subGroup === sg.title && f.group === g.title;
            });
            if (!subItems.length) {
              return;
            }
            const elem = {
              group: g.title,
              subGroups: true,
              compactMode: false,
              cols: [],
            };
            this.headers.forEach((h, index) => {
              if (h.name === "group") {
                return;
              }
              if (h.type === "groupName") {
                const elems = [{ subGroup: sg.title }].concat(
                  _.map(subItems, h.name),
                );
                if (newItems.find(ni => ni.group === g.title)) {
                  newItems.forEach(el => {
                    if (el.group === g.title) {
                      el.cols[index - 1] = el.cols[index - 1].concat(elems);
                    }
                  });
                } else {
                  elem.cols.push(elems);
                }
              } else if (h.type === "decimal") {
                const arr = _.map(subItems, h.name);
                const elems = [
                  {
                    subGroup: arr
                      .reduce((sum, current) => {
                        return sum + +current;
                      }, 0)
                      .toFixed(h.scale || 0),
                  },
                ].concat(arr);
                if (newItems.find(ni => ni.group === g.title)) {
                  newItems.forEach(el => {
                    if (el.group === g.title) {
                      el.cols[index - 1] = el.cols[index - 1].concat(elems);
                    }
                  });
                } else {
                  elem.cols.push(elems);
                }
              } else if (
                h.type === "defaultValue" &&
                this.flatItems.find(i => i.defaultSubGroupValues?.[h.name]) &&
                sg.deaultValues
              ) {
                const elems = [
                  {
                    subGroup: this.flatItems.find(
                      i => i.defaultSubGroupValues?.[h.name],
                    ).defaultSubGroupValues?.[h.name],
                  },
                ].concat(_.map(subItems, h.name));
                if (newItems.find(ni => ni.group === g.title)) {
                  newItems.forEach(el => {
                    if (el.group === g.title) {
                      el.cols[index - 1] = el.cols[index - 1].concat(elems);
                    }
                  });
                } else {
                  elem.cols.push(elems);
                }
              } else {
                const elems = [{ subGroup: "-" }].concat(
                  _.map(subItems, h.name),
                );
                if (newItems.find(ni => ni.group === g.title)) {
                  newItems.forEach(el => {
                    if (el.group === g.title) {
                      el.cols[index - 1] = el.cols[index - 1].concat(elems);
                    }
                  });
                } else {
                  elem.cols.push(elems);
                }
              }
            });
            if (!newItems.find(ni => ni.group === g.title)) {
              newItems.push(elem);
            }
          });
        }
      });

      this.groupedItems = newItems;
    },
    compactModeChange(item) {
      item.compactMode = !item.compactMode;
    },
  },
};
</script>
<style>
.align-top {
  vertical-align: top;
}
</style>
